import React from "react";
import { CommonImageComp, Hints } from "../index";
import { Box, type SxProps } from "@mui/material";
import { useThemeContext } from "../../../globalContext/global-context";

type CommonQuestionErrorCompProps = {
  questionText: string;
  errorText?: string;
  questionSx?: SxProps;
  image?: string | null;
  alt_text?: string | null;
  errorSx?: SxProps;
  boxWrapperSx?: SxProps;
};

const CommonQuestionErrorComp: React.FC<CommonQuestionErrorCompProps> = ({
  questionText,
  errorText,
  questionSx,
  image,
  alt_text,
  errorSx,
  boxWrapperSx,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const isImagePresent = !!(image && image.length > 0);
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        ...boxWrapperSx,
        flexDirection: "column",
      }}
    >
      <Hints text={questionText} sx={questionSx} variant="label" />
      {errorText && <Hints text={errorText} sx={errorSx} variant="error" />}
      {isImagePresent && (
        <CommonImageComp
          currentVal={{
            image: image,
            alt_text: alt_text ?? theme.copy.labels.questionImage,
          }}
          imageStyle={{
            borderRadius: `${theme.tokens.shape.radius.lg}px`,
            maxWidth: "100%",
            maxHeight: { md: "600px", xs: "400px" },
            margin: "0 auto",
            width: "auto",
            height: "auto",
          }}
        />
      )}
    </Box>
  );
};

export default CommonQuestionErrorComp;
